import PropTypes from "prop-types";
import { PROJECT_STEPS } from "./steps/projectSteps";

export default function ProjectStepper({ currentIndex, onStepChange }) {
  return (
    <div className="-mx-1 border-b border-slate-200">
      <div
        className="flex snap-x snap-mandatory gap-1 overflow-x-auto pb-0 scrollbar-thin md:flex-wrap md:overflow-visible"
        role="tablist"
        aria-label="Project creation steps"
      >
        {PROJECT_STEPS.map((step, index) => {
          const isActive = index === currentIndex;
          return (
            <button
              key={step.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              onClick={() => onStepChange(index)}
              className={[
                "relative shrink-0 snap-start whitespace-nowrap px-3 py-3 text-sm font-medium transition-colors duration-200",
                "first:pl-1",
                isActive ? "text-text-900" : "text-text-500 hover:text-text-700",
              ].join(" ")}
            >
              {step.label}
              <span
                className={[
                  "absolute bottom-0 left-0 right-0 h-0.5 origin-left rounded-full transition-transform duration-300 ease-out",
                  isActive ? "scale-x-100 bg-neutral-900" : "scale-x-0 bg-transparent",
                ].join(" ")}
                aria-hidden
              />
            </button>
          );
        })}
      </div>
    </div>
  );
}

ProjectStepper.propTypes = {
  currentIndex: PropTypes.number.isRequired,
  onStepChange: PropTypes.func.isRequired,
};
